/* src/app/private/components/view/roles/roles.component.scss */
/*# sourceMappingURL=roles.component.css.map */
